export enum SupportedErrorTexts {
  NO_NAME = 'NO_NAME',
  NO_COORDINATES = 'NO_COORDINATES',
  NO_DATE = 'NO_DATE',
  NO_CROP = 'NO_CROP',
  INCORRECT_CROP = 'INCORRECT_CROP',
  INCORRECT_DATE = 'INCORRECT_DATE',
}

export enum VIType {
  NDVI = 'ndvi',
  NDMI = 'ndmi',
  EVI = 'evi',
  S2MULTI = 's2multi',
}

export enum SupportedMapLayers {
  NONE = 'none',
  SOIL = 'soil',
  NDVI = VIType.NDVI,
  NDMI = VIType.NDMI,
  EVI = VIType.EVI,
  HOTSPOT = 'hotspot',
  YIELD = 'yield',
  CROP_PROGRESS = 'cropProgress',
}
